export const initialState = {
  item: {
    isDirty: false,
    saving: false,
    documentTypes: [],
    userGroups: [],
    userGroupsInEdit: false
  }
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnItemSaveStarted':
      return onItemSaveStarted(state);
    case 'OnItemSaved':
      return onItemSaved(state, action);
    case 'onItemSaveFailed':
      return onItemSaveFailed(state);
    case 'OnItemValuesChanged':
      return onItemValuesChanged(state, action);
    case 'OnDocumentTypeIdSelectionChanged':
      return onDocumentTypeIdSelectionChanged(state, action);
    case 'OnVerificationTypeUserGroupAdded':
      return onVerificationTypeUserGroupAdded(state, action);
    case 'OnVerificationTypeUserGroupChanged':
      return onVerificationTypeUserGroupChanged(state, action);
    case 'OnVerificationTypeUserGroupDelete':
      return onVerificationTypeUserGroupDelete(state, action);
    case 'OnCancelVerificationTypeUserGroup':
      return onCancelVerificationTypeUserGroup(state, action);
    case 'OnEditVerificationTypeUserGroup':
      return onEditVerificationTypeUserGroup(state, action);
    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { verificationType } = action;
  const { verificationTypeId } = verificationType;
  return {
    ...state,
    verificationTypeId,
    item: {
      ...verificationType,
      isDirty: false
    }
  };
};

const onItemSaved = (state, action) => {
  return {
    ...state,
    item: {
      ...state.item,
      ...action.verificationType,
      isDirty: false,
      saving: false
    }
  };
};

const onItemSaveStarted = state => {
  return {
    ...state,
    item: {
      ...state.item,
      saving: true
    }
  };
};

const onItemSaveFailed = state => {
  return {
    ...state,
    item: {
      ...state.item,
      saving: false
    }
  };
};

const onItemValuesChanged = (state, action) => {
  const { itemPropertyName, itemValue } = action;
  return {
    ...state,
    item: {
      ...state.item,
      [itemPropertyName]: itemValue,
      isDirty: true
    }
  };
};

const onDocumentTypeIdSelectionChanged = (state, action) => {
  const { index, itemValue } = action;
  return {
    ...state,
    item: {
      ...state.item,
      documentTypes: Object.assign([...state.item.documentTypes], {
        [index]: {
          ...state.item.documentTypes[index],
          isSelected: itemValue,
          verificationTypeXDocumentTypeId: 0 //ERPFINSLFO-20868 - temporary fix (to be addressed)
        }
      }),
      isDirty: true
    }
  };
};

function onVerificationTypeUserGroupChanged(state, action) {
  const { propName, propValue, index } = action;
  return {
    ...state,
    item: {
      ...state.item,
      userGroups: Object.assign([...state.item.userGroups], {
        [index]: {
          ...state.item.userGroups[index],
          editValue: {
            ...state.item.userGroups[index].editValue,
            [propName]: propValue
          }
        }
      }),
      isDirty: true
    }
  };
}

function onVerificationTypeUserGroupAdded(state, action) {
  const newVerificationTypeUserGroup = {
    verificationTypeId: action.verificationTypeId,
    userGroup: {},
    viewReportYN: true,
    viewSummaryYN: true,
    userGroupsInEdit: true,
    editValue: {
      verificationTypeId: action.verificationTypeId,
      userGroup: {},
      viewReportYN: true,
      viewSummaryYN: true
    }
  };
  const verificationTypeUserGroups = Object.assign([...state.item.userGroups]);
  verificationTypeUserGroups.unshift({ ...newVerificationTypeUserGroup });
  return {
    ...state,
    item: {
      ...state.item,
      userGroups: verificationTypeUserGroups
    },
    isDirty: true
  };
}

function onVerificationTypeUserGroupDelete(state, action) {
  const { index } = action;
  const newVerificationTypeUserGroups = Object.assign([...state.item.userGroups]);
  newVerificationTypeUserGroups.splice(index, 1);
  return {
    ...state,
    item: {
      ...state.item,
      userGroups: newVerificationTypeUserGroups,
      isDirty: true
    }
  };
}

function onCancelVerificationTypeUserGroup(state, action) {
  const { index } = action;
  const updatedValues = state.item.userGroups
    .map((value, idx) => (index === idx ? { ...value, userGroupsInEdit: false } : value))
    .filter((value, idx) => {
      return idx !== index || (value.userGroup && value.userGroup.id);
    });
  return {
    ...state,
    item: {
      ...state.item,
      userGroups: updatedValues
    }
  };
}

function onEditVerificationTypeUserGroup(state, action) {
  const { index } = action;
  const updatedValues = state.item.userGroups.map((value, idx) => {
    if (idx === index) {
      const { ...rest } = value;
      return {
        ...value,
        editValue: { ...rest },
        userGroupsInEdit: true
      };
    }
    return value;
  });

  return {
    ...state,
    item: {
      ...state.item,
      userGroups: updatedValues
    }
  };
}
